(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@amzn/ihm-associate-tools-js-lib", [], factory);
	else if(typeof exports === 'object')
		exports["@amzn/ihm-associate-tools-js-lib"] = factory();
	else
		root["@amzn/ihm-associate-tools-js-lib"] = factory();
})(self, () => {
return 